<template>
    <b-container fluid class="animated fadeIn">
        <h1>Cadastro de Limite Protestos</h1>
        <b-card>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between">
                        <div>
                            <b-button class="mx-1 fonte-branca" v-b-toggle.collapseOpcoesPesquisa variant="primary"><i class="fa fa-filter"></i> Opções de pesquisa</b-button>
                            <CompExibirOcultarColuna 
                                :fields="fields"
                                :showColunms="showColunms" 
                                @toggleColuna="toggleColuna" />
                        </div>
                    </div>
                    <div>
                        <b-collapse id="collapseOpcoesPesquisa" class="mt-2">
                            <b-card class="primary-semi p-2">
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Filtrar por:" label-for="filtrarPor" class="text-label">
                                            <multiselect
                                                v-model="filtrarPor"
                                                :show-labels="false"
                                                :options="opcoesFiltro"
                                                :multiple="true"
                                                :close-on-select="false"
                                                :clear-on-select="false"
                                                :preserve-search="true"
                                                placeholder="Selecione"
                                                track-by="id"
                                                label="filtro"
                                            >
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span
                                                        class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen"
                                                    >{{ values.length }} selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 1).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="Nome:" label-for="nome" class="text-label">
                                            <b-form-input v-model="filtro.nome" type="text" id="nome" maxlength="100" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 2).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="Nome Simplificado:" label-for="nomeSimplificado" class="text-label">
                                            <b-form-input v-model="filtro.nomeSimplificado" type="text" id="nomeSimplificado" maxlength="100" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 3).length > 0)">
                                    <b-col xs="6" sm="6" md="6" lg="6" xl="6">
                                        <b-form-group label="Última Remessa:" label-for="ultimaRemessa" class="text-label">
                                            <the-mask
                                                    id="ultimaRemessa"
                                                    class="form-control"
                                                    v-model="filtro.ultimoSeqRemessaH8"
                                                    :mask="'##########'"
                                            />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 4).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group
                                            label="Município Sede Protesto:"
                                            label-for="municipioProtesto">
                                            <multiselect
                                                name="municipioProtesto"
                                                v-model="filtro.municipioSedeProtesto"
                                                :show-labels="false"
                                                :options="dados.municipios"
                                                :multiple="false"
                                                :close-on-select="true"
                                                :clear-on-select="true"
                                                :preserve-search="false"
                                                placeholder="Selecione"
                                                track-by="codMunicipio"
                                                label="nome"
                                            >
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 5).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group
                                            label="Município Sede Ajuizamento:"
                                            label-for="municipioAjuizamento">
                                            <multiselect
                                                name="municipioAjuizamento"
                                                v-model="filtro.municipioSedeAjuizamento"
                                                :show-labels="false"
                                                :options="dados.municipios"
                                                :multiple="false"
                                                :close-on-select="true"
                                                :clear-on-select="true"
                                                :preserve-search="false"
                                                placeholder="Selecione"
                                                track-by="codMunicipio"
                                                label="nome"
                                            >
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 6).length > 0)">
                                    <b-col xs="6" sm="6" md="6" lg="6" xl="6">
                                        <b-form-group label="Código TJ:" label-for="codigoTJ" class="text-label">
                                            <the-mask
                                                    id="codigoTJ"
                                                    class="form-control"
                                                    v-model="filtro.codigoTabelaTj"
                                                    :mask="'##########'"
                                            />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 7).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="Situação:" label-for="situacao" class="text-label">
                                            <b-form-checkbox-group
                                                id="checkboxSituacao"
                                                v-model="filtro.situacao"
                                                :options="dados.situacao"
                                                name="checkboxSituacao">
                                            </b-form-checkbox-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <hr>
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <b-button class="ml-2" variant="secondary" @click="limparFiltro">
                                                <i class="fa fa-eraser"></i> Limpar
                                            </b-button>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-collapse>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between">
                        <div>
                            <b-button variant="primary" class="fonte-branca ml-1" @click="filtrar">
                                <i class="fa fa-search"></i> Pesquisar
                            </b-button>
                            <b-button variant="primary" class="fonte-branca ml-1" :disabled="selecteds.length == 0" @click.prevent="carregarAlterar">
                                <i class="fa fa-pencil"></i> Alterar
                            </b-button>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <b-col xs="12">
                        <div>
                            <b-row class="d-flex justify-content-between">
                                <b-col>
                                    <label class="mt-3">Total de Comarcas Exibidas - <strong>{{ configTable.rows }}</strong></label>
                                </b-col>
                                <b-col>
                                    <CompPaginacao :configTable="configTable" />
                                </b-col>
                            </b-row>
                            <TabelaLimiteProtesto
                                :resultado="resultado"
                                :fields="fields"
                                :configTable="configTable"
                                :selecteds="selecteds"
                                @sortingChanged="consultar"
                                @consultar="consultar" />
                            <b-row class="d-flex justify-content-between">
                                <b-col align-self="end">
                                    <label style="float:right">Total de Comarcas Selecionadas - <strong>{{selecteds.length}}</strong></label>
                                </b-col>
                            </b-row>
                            <b-row class="d-flex justify-content-between">
                                <b-col></b-col>
                                <b-col>
                                    <CompPaginacao :configTable="configTable" />
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                </b-col>
            </b-row>
            <b-modal ref="modalAlterar" size="lg" title="Alterar Limite de Protestos" cancel-title="Fechar">
                <b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <b-form-group label="Número de Limite de Protestos:" label-for="limiteProtestos" class="text-label">
                            <the-mask
                                    id="limiteProtestos"
                                    class="form-control"
                                    v-model="limiteProtestos"
                                    :mask="'#########'"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <template v-slot:modal-footer="{  }">
                    <div class="d-flex justify-content-between">
                        <b-button variant="primary" class="fonte-branca ml-1" @click="alterar">
                            Salvar
                        </b-button>
                        <b-button variant="secondary" class="fonte-branca ml-1" @click="hideAlterar">
                            Cancelar
                        </b-button>
                    </div>
                </template>
            </b-modal>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import CompExibirOcultarColuna from '../components/CompBotaoExibirOcultarColuna'
import CompPaginacao from '../components/CompPaginacao'
import TabelaLimiteProtesto from './TabelaLimiteProtesto'

export default {
    name: 'CadastroLimiteProtesto',
    components: {
        CompExibirOcultarColuna,
        CompPaginacao,
        TabelaLimiteProtesto
    },
    data() {
        return {
            fields: [
                {
                    key: "selecionar",
                },
            ],
            showColunms: [],
            filtro: {
                nome: null,
                nomeSimplificado: null,
                ultimoSeqRemessaH8: null,
                municipioSedeAjuizamento: null,
                municipioSedeProtesto: null,
                codigoTabelaTj: null,
                situacao: []
            },
            dados: {
                municipios: [],
                situacao: [
                    { text: 'Ativo', value: 1 },
                    { text: 'Inativo', value: 0 }
                ]
            },
            filtrarPor: [],
            opcoesFiltro: [
                {
                    id: 1,
                    filtro: 'Nome'
                },
                {
                    id: 2,
                    filtro: 'Nome Simplificado'
                },
                {
                    id: 3,
                    filtro: 'Última Remessa'
                },
                {
                    id: 4,
                    filtro: 'Município Sede Protesto'
                },
                {
                    id: 5,
                    filtro: 'Município Sede Ajuizamento'
                },
                {
                    id: 6,
                    filtro: 'Código TJ'
                },
                {
                    id: 7,
                    filtro: 'Situação'
                },
            ],
            configTable: {
                perPage: 100,
                sortField: 'nomeSimplificado',
                sortOrder: 'asc',
                currentPage: 1,
                rows: 0,
                checkedAll: false,
                load: false,
            },
            resultado: [],
            selecteds: [],
            limiteProtestos: null
        }
    },
    methods: {
        carregarAlterar() {
            this.$refs['modalAlterar'].show();
        },

        hideAlterar() {
            this.$refs['modalAlterar'].hide();
        },

        alterar() {
            if(this.limiteProtestos == null || this.limiteProtestos < 0) {
                return;
            }

            const urlApi = process.env.VUE_APP_ROOT_API;
            const token = JSON.parse(this.$store.getters.getUser).access_token;

            let limiteProtestoObjeto = {
                limiteProtestos: this.limiteProtestos,
                comarcas: this.selecteds
            }

            axios.post(`${urlApi}/v1/comarca/salvarLimiteProtestos`, limiteProtestoObjeto, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).then(response => {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Limites de Protestos alterados com sucesso!!!'] });
                this.limiteProtestos = null;
                this.consultar();
                window.scrollTo(0,0);
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.hideAlterar();
            });
        },

        /**
         * Consultar
         */
        async consultar() {
            this.selecteds = []
            const urlApi = process.env.VUE_APP_ROOT_API

            const filtro = this.obterFiltro()

            let perPageStr = `&perPage=${this.configTable.perPage}`
            if(this.configTable.perPage === 'Todos') {
                perPageStr = ''
                this.configTable.currentPage = 1
                this.configTable.rows = 0
            }

            this.loadingEnter()
            axios.post(`${urlApi}/v1/comarca/consultarLimiteProtestos?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
                this.resultado = response.data.resultado
                if(this.configTable.perPage !== 'Todos') {
                    this.configTable.rows = response.data.rows
                }
            }).finally(() => {
                this.loadingExit()
            })

        },

        /**
         * Obter filtro
         */     
        obterFiltro() {
            return {
                nome: (this.filtrarPor.filter(e => e.id == 1).length > 0) ? this.filtro.nome : null,
                nomeSimplificado: (this.filtrarPor.filter(e => e.id == 2).length > 0) ? this.filtro.nomeSimplificado : null,
                ultimoSeqRemessaH8: (this.filtrarPor.filter(e => e.id == 3).length > 0) ? this.filtro.ultimoSeqRemessaH8 : null,
                municipioSedeProtesto: (this.filtrarPor.filter(e => e.id == 4).length > 0) ? this.filtro.municipioSedeProtesto : null,
                municipioSedeAjuizamento: (this.filtrarPor.filter(e => e.id == 5).length > 0) ? this.filtro.municipioSedeAjuizamento : null,
                codigoTabelaTj: (this.filtrarPor.filter(e => e.id == 6).length > 0) ? this.filtro.codigoTabelaTj : null,
                situacoes: (this.filtrarPor.filter(e => e.id == 7).length > 0) ? this.filtro.situacao : null,
            }
        },

        /**
         * Limpar os filtros de pesquisa
         */
        limparFiltro() {
            this.filtro = {
                nome: null,
                nomeSimplificado: null,
                ultimoSeqRemessaH8: null,
                municipioSedeProtesto: null,
                municipioSedeAjuizamento: null,
                codigoTabelaTj: null,
                situacao: null
            }
            this.filtrarPor = []
            this.filtrar();
        },

        /**
         * Filtrar a consulta
         */
        filtrar() {
            this.configTable.currentPage = 1
            this.configTable.rows = 0
            this.configTable.checkedAll = false
            this.resultado = []
            this.selecteds = []
            this.consultar()
        },

        /**
         * Lógica dos checks em nível dinâmico
         */
        toggleColuna(i) {
            let ativo;
            if(this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1)
                this.fields[i].thClass = 'd-none'
                this.fields[i].tdClass = 'd-none'
                ativo = false
            } else {
                this.showColunms.push(i)
                this.fields[i].thClass = ''
                this.fields[i].tdClass = ''
                ativo = true
            }

            this.refreshConfigColunm(i, ativo)
        },

        /**
         * Atualiza as configurações de coluna do usuário
         */
        async refreshConfigColunm(i, ativo) {
            const token = JSON.parse(this.$store.getters.getUser).access_token

            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo,
            }
            const urlApi = process.env.VUE_APP_ROOT_API
            axios.post(`${urlApi}/v1/funcionalidade/atualizarConfiguracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })          
        },

        /**
         * Listar municípios
         */
        async listarMunicipios() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/municipio/listarPR`)
            .then(response => {
              this.dados.municipios = response.data
            })
        },

        /**
         * Obter configurações de colunas do usuário
         */
        async obterConfiguracaoUsuario() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token
            const funcionalidade = 'limiteProtestos'

            this.loadingEnter()
            axios.get(`${urlApi}/v1/funcionalidade/obterConfiguracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                response.data.forEach((field, i) => {
                    if(field.ativo) {
                        this.showColunms.push(i + 1)
                    }
                    this.fields.push({
                        key: `${i + 1}`,
                        label: `${field.descricao}`,
                        sortable: true,
                        sortDirection: "desc",
                        class: this.checkClassTable(i),
                        thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                        codColunaFuncionalidade: field.codColunaFuncionalidade,
                        codFuncionalidade: field.codFuncionalidade
                    })
                })
            })
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        /**
         * Verifica 'class' da tabela
         */
        checkClassTable(i) {
            if(i == 1 || i == 4 || i == 5 || i == 7 || i == 8)
                return 'text-center justify-content-center'
            return 'justify-content-center'
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingEnter() {
            this.configTable.load = true
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingExit() {
            this.configTable.load = false
        }
    },
    watch: {
        perPage() {
            this.configTable.currentPage = 1
            this.consultar()
        }
    },
    computed: {
        perPage() {
            return this.configTable.perPage
        },
    },
    mounted() {
        this.$store.commit("setMessages", {});

        const msgComarca = this.$store.getters.getMsgComarca;
        if(msgComarca) {
            this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [msgComarca] });
            this.$store.commit("setMsgComarca", null)
        }

        this.obterConfiguracaoUsuario()
        this.listarMunicipios()

        this.consultar()

    }
    
}
</script>

<style scoped>

</style>